import { render, staticRenderFns } from "./TaskBlockCreate.vue?vue&type=template&id=5d19392a&scoped=true&"
import script from "./TaskBlockCreate.vue?vue&type=script&lang=js&"
export * from "./TaskBlockCreate.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockCreate.vue?vue&type=style&index=0&id=5d19392a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19392a",
  null
  
)

export default component.exports